import React, { useEffect, useState, useCallback } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { getProjects, adminGetInvestors, adminGetHoldings, adminGetListings } from '../lib/api';
import ProjectsTab from '../components/admin/ProjectsTab';
import InvestorsTab from '../components/admin/InvestorsTab';
import HoldingsTab from '../components/admin/HoldingsTab';
import MarketTab from '../components/admin/MarketTab';
import StatementsTab from '../components/admin/StatementsTab';
import AuditTab from '../components/admin/AuditTab';

const tabBtn = 'data-[state=active]:bg-farmway-gold data-[state=active]:text-farmway-green';

export default function Admin() {
  const [projects, setProjects] = useState([]);
  const [investors, setInvestors] = useState([]);
  const [holdings, setHoldings] = useState([]);
  const [listings, setListings] = useState([]);

  const loadAll = useCallback(async () => {
    try {
      const [p, i, h, l] = await Promise.all([getProjects(), adminGetInvestors(), adminGetHoldings(), adminGetListings()]);
      setProjects(p); setInvestors(i); setHoldings(h); setListings(l);
    } catch (e) { console.error('Failed to load admin data', e); }
  }, []);
  useEffect(() => { loadAll(); }, [loadAll]);

  return (
    <div className="min-h-screen bg-farmway-green pt-28">
      <div className="container-fw pb-24">
        <span className="eyebrow">Admin</span>
        <h1 className="mt-3 display-xl text-4xl text-farmway-cream sm:text-5xl">Control room</h1>

        <Tabs defaultValue="projects" className="mt-8">
          <TabsList className="flex-wrap bg-farmway-green-mid/50">
            <TabsTrigger value="projects" className={tabBtn} data-testid="projects-tab">Projects</TabsTrigger>
            <TabsTrigger value="investors" className={tabBtn} data-testid="investors-tab">Investors</TabsTrigger>
            <TabsTrigger value="holdings" className={tabBtn} data-testid="holdings-tab">Holdings</TabsTrigger>
            <TabsTrigger value="market" className={tabBtn} data-testid="market-tab">Marketplace</TabsTrigger>
            <TabsTrigger value="statements" className={tabBtn} data-testid="statements-tab">Statements</TabsTrigger>
            <TabsTrigger value="audit" className={tabBtn} data-testid="audit-tab">Audit</TabsTrigger>
          </TabsList>

          <TabsContent value="projects" className="mt-6">
            <ProjectsTab projects={projects} onChanged={loadAll} />
          </TabsContent>
          <TabsContent value="investors" className="mt-6">
            <InvestorsTab investors={investors} onChanged={loadAll} />
          </TabsContent>
          <TabsContent value="holdings" className="mt-6">
            <HoldingsTab projects={projects} holdings={holdings} onChanged={loadAll} />
          </TabsContent>
          <TabsContent value="market" className="mt-6">
            <MarketTab listings={listings} onChanged={loadAll} />
          </TabsContent>
          <TabsContent value="statements" className="mt-6">
            <StatementsTab />
          </TabsContent>
          <TabsContent value="audit" className="mt-6">
            <AuditTab />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
